import { render } from "./ContactosContent.vue?vue&type=template&id=f4df4412"
import script from "./ContactosContent.vue?vue&type=script&lang=js"
export * from "./ContactosContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__